export enum Cv {
  NoCvRequired = 'no_cv_required',
  CvRequired = 'cv_required',
  DetailedCv = 'detailed_cv',
  CareerChangers = 'careerchangers_need_cv',
  AssistantsDetailedCv = 'assistants_need_detailed_cv',
}

export enum Certificate {
  NoCertificateRequired = 'no_certificate_required',
  CertificateRequired = 'certificate_required',
  CertificateAndReportcard = 'certificate_and_reportcard',
  Assistants = 'assistants_need_certificate',
}

export const CERTIFICATE_REQUIREMENTS = [Certificate.CertificateRequired, Certificate.CertificateAndReportcard, Certificate.Assistants];
